import { JSONSchema7 } from 'json-schema'

export const isDateField = (schema?: JSONSchema7 | null) =>
  schema?.type === 'string' &&
  schema?.format &&
  ['date', 'datetime'].includes(schema?.format)
